import React from 'react';
import { useFormController } from '../hooks/useFormController.js';
import { FormFields } from './FormFields.js';

var SchemaFields = function SchemaFields() {
  var _useFormController = useFormController(),
    getOptions = _useFormController.getOptions;

  // Grap the schema
  var _getOptions = getOptions(),
    schema = _getOptions.schema;
  return /*#__PURE__*/React.createElement(FormFields, {
    schema: schema
  });
};

export { SchemaFields };
